export const content = "BetterHelp sessions take place online through video. We don't offer in-person appointments.\n";
